import { render } from "./RenewSession.vue?vue&type=template&id=2c223c83&scoped=true&ts=true"
import script from "./RenewSession.vue?vue&type=script&lang=ts"
export * from "./RenewSession.vue?vue&type=script&lang=ts"

import "./RenewSession.vue?vue&type=style&index=0&id=2c223c83&scoped=true&lang=css"

import exportComponent from "/builds/tmobile/tss/projects/esd/common/techapps-host-ext/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c223c83"]])

export default __exports__